"use client";

import type { AboutData } from "@/services/public.service";

export default function AboutStats({ about, isAr }: { about: AboutData; isAr: boolean }) {
  const stats = about.stats || [];
  if (stats.length === 0) return null;

  return (
    <section className="bg-clay-600 text-white py-14">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {stats.map((s, i) => (
            <div key={i}>
              <p className="font-display text-4xl md:text-5xl font-extrabold mb-1">{s.value}</p>
              <p className="text-white/80 text-sm">{isAr ? s.label.ar : s.label.en}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
